import React from 'react';
import { tokens } from './tokens';

export const GlobalStyles: React.FC = () => {
  return (
    <style dangerouslySetInnerHTML={{
      __html: `
      :root {
        --primary: ${tokens.colors.primary.DEFAULT};
        --primary-foreground: ${tokens.colors.primary.foreground};
        --secondary: ${tokens.colors.secondary.DEFAULT};
        --background: ${tokens.colors.background.light};
        --foreground: ${tokens.colors.foreground.light};
        --surface: ${tokens.colors.surface.light};
        --border: ${tokens.colors.surface.border};
        --muted: ${tokens.colors.muted.light};
        --muted-foreground: ${tokens.colors.muted.text};

        font-family: ${tokens.typography.fontSans};
        scroll-behavior: smooth;
      }

      .dark {
        --primary: ${tokens.colors.primary.light};
        --background: ${tokens.colors.background.dark};
        --foreground: ${tokens.colors.foreground.dark};
        --surface: ${tokens.colors.surface.dark};
        --border: ${tokens.colors.surface.borderDark};
        --muted: ${tokens.colors.muted.dark};
        --muted-foreground: ${tokens.colors.muted.textDark};
      }

      [data-view-mode="high-contrast"] {
        --primary: #FFFF00 !important;
        --primary-foreground: #000000 !important;
        --secondary: #00FFFF !important;
        --background: #000000 !important;
        --foreground: #FFFFFF !important;
        --surface: #000000 !important;
        --border: #FFFFFF !important;
        --muted: #FFFFFF !important;
        --muted-foreground: #FFFF00 !important;
        font-size: 110%;
      }

      [data-view-mode="high-contrast"] img {
         filter: grayscale(100%) contrast(120%);
      }

      body {
        background-color: var(--background);
        color: var(--foreground);
        transition: ${tokens.transitions.default};
        -webkit-font-smoothing: antialiased;
        overflow-x: hidden;
      }

      ::-webkit-scrollbar {
        width: 10px;
      }
      ::-webkit-scrollbar-track {
        background: var(--background);
      }
      ::-webkit-scrollbar-thumb {
        background: var(--border);
        border-radius: 5px;
        border: 2px solid var(--background);
      }
      ::-webkit-scrollbar-thumb:hover {
        background: var(--muted-foreground);
      }

      ::selection {
        background: var(--primary);
        color: var(--primary-foreground);
      }

      :focus-visible {
        outline: 2px solid var(--primary);
        outline-offset: 2px;
      }
    `}} />
  );
};
